<template lang="pug">
  v-container.px-10(fluid)
    v-row
      v-col
        .section__title {{ this.instance.name }}
    v-row
      v-col(cols="4")
        v-text-field(
          :value="instance.name",
          @input="inputName",
          :label="$t('EdiMap.name')",
          
        )
      v-col(cols="6")
        v-text-field(
          :value="instance.description",
          @input="inputDescription",
          :label="$t('EdiMap.description')",
          
        )
      v-col(cols="2")
        v-select(
              :label="$t('Common.type')",
              :value="instance.type",
              @input="selectType",
              :items="$store.state.schema.all",
              item-text="name",
              item-value="name",
             
             )
    v-row
        v-col(cols="3")
            g-btn.background(class="h9 primary--text" @click.stop="onClick") {{$t('Common.add')}} {{$t('EdiMapField._Name')}}
    v-row
      v-col(cols="12")
        v-jsoneditor(v-model="instance.fields",
                    :plus="false",
                    :options="editorOptions",
                    @error="onError",
                    )

</template>
<script>
import EntityMixin from '@/mixins'
import VJsoneditor from 'v-jsoneditor/src/index'

export default {
  mixins: [EntityMixin],
  name: 'edi-map-add',
  components: {
      VJsoneditor
  },
  props: ['path', 'entity'],
  data: () => ({
    p: {},
    businessScopes: [],
    newField: {
          'entity': "",
          'extraFieldId': null,
          'name': "",
          'type': "",
          'alias': "",
          'multiple': false,
          'primitive': true,
          'description': null,
          'rules': null,
          'extra': false,
          '_Entity': "EdiMapField"
        },
    }),
    methods: {
        onError() {
            console.log('error')
        },
        selectType(event) {
            this.instance.type = event;
            this.instance.alias = event;
        },
        inputName(event) {
            this.instance._Name = event;
            this.instance.name = event;
        },
        inputDescription(event) {
            this.instance.description = event;
        },
        onClick() {
            this.instance.fields.push(this.newField);
        },
    },
  computed: {
    errors(){
     return "";
    },
    uid() {
      return this.$route.params.item;
    },
    editorOptions()
    {
        return {
            modes: ['tree','text'],
            enableSort: false,
            onChangeText: function(input) {
                this.instance.fields = input;
            },
            name: this.instance.name,
        }
    }
  },
  async created() {
    if(!this.uid) {
      this.$store.commit(this.setInstancePathAction, { path: this.path + '.businessScope', value: this.$store.state.user.user.businessScope })
      
      //Create new clean instance if there's no UID
      this.instance = {
          _Entity: "EdiMap",
          entityState: 4,
          businessScopeId: 1,
          hidden: true,
          fields: [],
          name: '',
          _Name: '',
      };

      this.instance.fields.push(this.newField);
    }
  },
}
</script>
<style>
.v-text-field--filled input {
  margin-top: 16px !important;
}

.v-text-field--filled > .v-input__control > .v-input__slot {
  min-height: inherit !important;
}
</style>
